// export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://192.168.0.70:8888/graphql';
// export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://koskk.ddns.net:8888/graphql';
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8888';
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN || '';
export const ENV_NAME = process.env.ENV_NAME || 'development';